<template>
    <div>
        <v-dialog v-model="rankdialog" max-width="900px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on"
           >+</v-btn>
          </template>
          <v-card>
            <v-card-title>
            <span class="headline mb-4">
                {{ isEdit ? $t('Setuprankmapset.editrankmappingdetails') : $t('Setuprankmapset.rankmappingdetails') }}
            </span>
            </v-card-title>
            <v-card-text>
              <v-container>
                    <v-row>
                      <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                        <v-text-field
                            outlined
                            :label="this.$t('Setuprankmapset.uptoscore')"
                            type="number"
                            :rules="[rules.required]"
                            v-model="formData.uptoscore"
                            dense
                            class="v-input"
                        ></v-text-field>
                    </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="4" sm="8" class="pb-n4 mt-n8">
                        <v-text-field
                            outlined
                            :label="this.$t('Setuprankmapset.rank')"
                            type="number"
                            :rules="[rules.required]"
                            v-model="formData.rank"
                            dense
                            class="v-input"
                        ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="4" sm="8" class="pb-n4 mt-n8">
                        <v-text-field
                            outlined
                            :label="this.$t('pmassementrecord.distribution')"
                            type="number"
                            :rules="[rules.required]"
                            v-model="formData.distribution"
                            dense
                            class="v-input"
                        ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                        <!-- <v-checkbox
                            outlined
                            ref="isLast"
                            v-model="formData.isLast"
                            :label="this.$t('Setuprankmapset.isLast')"
                            @change="updateValue"
                            dense
                        ></v-checkbox> -->

                        <v-checkbox
                            outlined
                            ref="isMedian"
                            v-model="formData.isMedian"
                            :label="this.$t('Setuprankmapset.isMedian')"
                            dense
                        ></v-checkbox>
                        </v-col>
                    </v-row>
            </v-container>
            </v-card-text>

            <v-card-text v-if="isErr" class="mt-n12">
                <span style="font-weight: bold; color: red">{{errMsg}}</span>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="saveRankInput">{{$t('button.save')}}</v-btn>
              <v-btn color="red darken-1" text @click="closeRankInput">{{$t('button.cancel')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> 

        <v-data-table
            :headers="this.parentObject.tabHeader"
            :items="detailItem"
            class="elavation-1"
            fixed-header
            :sort-by="['code']"
        >
            <template v-slot:[`item.action`]="{ item }">
                <v-icon
                    small
                    class="mr-2"
                    @click="modifyItemHandler(item)"
                >
                    mdi-pen
                </v-icon>
                <v-icon
                    small
                    class="ml-3 mr-2"
                    @click="deleteItemHandler(item)"
                >
                    mdi-delete
                </v-icon>
            </template>

            <div v-if="isErr">
            <app-error
                v-bind:parentError="{
                data: this.errMsg,
                isErr: this.isErr,
                }"
                v-on:closeError="isErr = $event"
            />
            </div>

        </v-data-table>
    </div>
</template>

<script>
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
    props: {
        parentObject: Object
    },

    components: {
        "app-error": ErrorDialog,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            rankdialog: false,
            detailItem: this.parentObject.detailItem,
         
            formData: {
                pmrankmapsetid: this.parentObject.pmrankmapsetid,
                uptoscore: null,
                rank: null,
                distribution: null,
                isLast: false,
                isMedian: false,
                rectimestamp: null,
                updatedby: null,
                stamp: 0,
                userid: this.$store.getters.userId,
            },

            isEdit: false,

            //error msg and dialog, check for duplicates vars
            isErr: false,
            errMsg: '',
        }
    },

    methods: {
        modifyItemHandler(item) {
            this.isEdit = true;
            this.rankdialog = true;
            this.formData = item;
        },

        deleteItemHandler(item) {
            const vm = this;

            if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
                return false;
            }

            if (confirm(this.$t('pmrankmapset.deleterank', { code: item.rank }))) {
                this.$store.dispatch('delete', {url: "/rankmapsetdetails/" + item.id})
                .then(function () {
                    const index = vm.detailItem.findIndex(detail => detail.id === item.id);
                    if (index !== -1) {
                        vm.detailItem.splice(index, 1);
                    }
                })
                .catch(function (err) {
                    vm.errMsg = err;
                });
            }
        },

        saveRankInput() {
            const vm = this;

            if (this.isEdit) {//Edit
                if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
                    return false;
                }

                // Find the index of the item being edited
                const index = this.detailItem.findIndex(item => item.id === this.formData.id);

                // Calculate total distribution excluding the item being edited
                let totalDistribution = this.detailItem.reduce((sum, item, idx) => {
                    // Exclude the item being edited from the sum
                    return idx !== index ? sum + Number(item.distribution) : sum;
                }, 0);

                let newDistribution = Number(this.formData.distribution);

                // Check if the new distribution would cause the total to exceed 100
                if (totalDistribution + newDistribution > 100) {
                    vm.isErr = true;
                    vm.errMsg = "Total distribution exceeds 100. Please enter a new record with a lower distribution.";
                    return false;
                }
                this.formData.userid= this.$store.getters.userId;
                this.$store.dispatch('put', {url: "/rankmapsetdetails/" + this.formData.id, payload: this.formData})
                .then((res) => {
                    if (res.data.error) {
                        vm.isErr = !vm.isErr;
                        if (Array.isArray(res.data.error)) {
                            vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                        } else {
                            vm.errMsg = res.data.error;
                        }
                    } else {
                        const index = this.detailItem.findIndex(item => item.id === this.formData.id);
                        if (index !== -1) {
                            this.detailItem[index] = { ...this.formData };
                            // this.detailItem[index].isLastText = this.formData.isLast === true ? 'Yes' : 'No';
                            // this.detailItem[index].isMedianText = this.formData.isMedian === true ? 'Yes' : 'No';
                            // working but still no update front end, need to do some improvement
                        }
                        this.rankdialog = false;
                        this.isEdit = false;
                        this.resetSelections();
                    }
                })
                .catch((err) => {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                    console.log("err", err);
                });
            } else { //Add
                if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
                    return false;
                }

                //Distribution must < 100
                let totalDistribution = this.detailItem.reduce((sum, item) => sum + Number(item.distribution), 0);
                let newDistribution = Number(this.formData.distribution);

                if (totalDistribution + newDistribution > 100) {
                    vm.isErr = true;
                    vm.errMsg = "Total distribution exceeds 100. Please enter a new record with a lower distribution.";
                    return false;
                }

                this.$store.dispatch('post', {url: "/rankmapsetdetails/create", payload: this.formData})
                .then((res) => {
                    if (res.data.error) {
                        vm.isErr = !vm.isErr;
                        if (Array.isArray(res.data.error)) {
                            vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                        } else {
                            vm.errMsg = res.data.error;
                        }
                    } else {
                        this.detailItem.push(res.data.result);
                        this.rankdialog = false;
                        this.resetSelections();
                    }
                })
                .catch((err) => {
                    vm.isErr = !vm.isErr;
                    vm.errMsg = err;
                    console.log("err", err);
                });
            }
        },

        closeRankInput() {
            this.rankdialog = false;
            this.isErr = false;
            this.isEdit = false;

            // reset the form fields
            this.resetSelections();
        },

        resetSelections() {
            this.formData = {
                pmrankmapsetid: this.parentObject.pmrankmapsetid,
                uptoscore: null,
                rank: null,
                distribution: null,
                isLast: false,
                isMedian: false,
                rectimestamp: null,
                updatedby: null,
                stamp: 0,
                userid: this.$store.getters.userId,
            }
        },          
    },

    mounted() {
    }
}
</script>

<style>

.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-outer-spin-button,
.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-inner-spin-button
{
-webkit-appearance: none;
margin: 0;
}
</style>